import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import MarketingLayout from "@/components/MarketingLayout";
import Home from "@/pages/Home";
import Models from "@/pages/Models";
import ModelProfile from "@/pages/ModelProfile";
import Casting from "@/pages/Casting";
import Archive from "@/pages/Archive";
import NewsDetail from "@/pages/NewsDetail";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Apply from "@/pages/Apply";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminHeroVideoPicker from "@/pages/admin/HeroVideoPicker";
import AdminInstagramManager from "@/pages/admin/InstagramManager";
import AdminLatestManager from "@/pages/admin/LatestManager";
import AdminCastingsManager from "@/pages/admin/CastingsManager";
import AdminPartnersManager from "@/pages/admin/PartnersManager";
import PartnerLogin from "@/pages/partner/Login";
import PartnerApplications from "@/pages/partner/Applications";
import PartnerApplicationDetail from "@/pages/partner/ApplicationDetail";
import FAQ from "@/pages/FAQ";
import ApplicationGuide from "@/pages/ApplicationGuide";
import ApplicationStatus from "@/pages/ApplicationStatus";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import CodeOfConduct from "@/pages/CodeOfConduct";
import Scouting from "@/pages/Scouting";
import { LanguageProvider } from "@/lib/i18n";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                border: "1px solid rgba(0,0,0,0.1)",
                borderRadius: 0,
                color: "#0A0A0A",
                fontFamily: "'Hanken Grotesk', sans-serif",
              },
            }}
          />
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/models" element={<Models />} />
              <Route path="/models/:slug" element={<ModelProfile />} />
              <Route path="/casting" element={<Casting />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/code-of-conduct" element={<CodeOfConduct />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/apply/guide" element={<ApplicationGuide />} />
              <Route path="/scouting" element={<Scouting />} />
              <Route path="/status" element={<ApplicationStatus />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/hero-video" element={<AdminHeroVideoPicker />} />
            <Route path="/admin/instagram" element={<AdminInstagramManager />} />
            <Route path="/admin/latest" element={<AdminLatestManager />} />
            <Route path="/admin/castings" element={<AdminCastingsManager />} />
            <Route path="/admin/partners" element={<AdminPartnersManager />} />
            <Route path="/partner/login" element={<PartnerLogin />} />
            <Route path="/partner/applications" element={<PartnerApplications />} />
            <Route path="/partner/applications/:id" element={<PartnerApplicationDetail />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
